import { useEffect } from 'react'
import { APP_ROOT_ID } from '../constants/appConstants'

const useScrollToElement = (): void => {
    useEffect(() => {
        if (document.location.hash) {
            const element = document
                .getElementById(decodeURIComponent(document.location.hash.substr(1)))

            if (element !== null) {
                const root = document.getElementById(APP_ROOT_ID)
                const { top } = element.getBoundingClientRect()

                if (root) {
                    root.scrollTo(0, root.scrollTop + top)
                } else {
                    const y = top + window.scrollY
                    window.scrollTo(0, y)
                }
            }
        }
    }, [])
}

export default useScrollToElement
